import React, { useEffect, useState } from 'react';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Cnt } from '../../Cnt.ThreeDeeCrate.SDK/Cnt.ThreeDeeCrate.SDK';

interface ImportButtonProps {
  model: Cnt.ThreeDeeCrate.SDK.ContainerModelDTO | null;
}

export const ImportButton: React.FC<ImportButtonProps> = ({ model }) => {
  const [copied, setCopied] = useState(false);

  const copyToClipboard = async () => {
    const token = localStorage.getItem("access_token") ?? "";

    const payload = {
      accessToken: token,
      model: model
    };

    await navigator.clipboard.writeText(JSON.stringify(payload));
    setCopied(true);
  };

  const checkClipboard = async () => {
    try {
      const text = await navigator.clipboard.readText();
      if (!text.includes('"accessToken":')) {
        setCopied(false);
      }
    } catch {
      // clipboard access might fail if not in user gesture; ignore
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      checkClipboard();
    }, 2000); // Check every 2 seconds

    return () => clearInterval(interval);
  }, []);

return (
  <div className="d-none d-md-block">
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id="tooltip-import">{copied ? 'Already copied' : 'Import this model into Unity.'}</Tooltip>}
    >
      <button
        className={`btn ${copied ? 'btn-secondary' : 'btn-dark'} mt-2 float-end`}
        disabled={copied}
        onClick={copyToClipboard}
        type="button"
      >
        {copied ? '✅ Opening importer...' : '🎮 Import into Unity'}
      </button>
    </OverlayTrigger>
  </div>
);

};
